import { Button, View } from "@/components/ui";
import { ReportIssueForm } from "../report-issue-form";
import type { VisitIssueScreenProps } from "./type";
import { MobileFullscreenModal } from "@/components/shared/mobile-fullscreen-modal";
import { Typography } from "@/components/shared/typography";

export function VisitIssueScreen({
  open,
  title,
  description,
  loading,
  showAttachments,
  onClose,
  onSubmit,
  form,
}: VisitIssueScreenProps) {
  return (
    <MobileFullscreenModal
      open={open}
      onClose={onClose}
      title={title}
      FooterComponent={
        <Button
          variant="primary"
          color="CTA"
          fullWidth="full"
          onClick={onSubmit}
          loading={loading}
          disabled={loading}
          children="Submit"
        />
      }
    >
      <View className="flex flex-col gap-2">
        <Typography variant="body-md" color="foreground-intermediate">
          {description}
        </Typography>
        <ReportIssueForm form={form} showAttachments={showAttachments} />
      </View>
    </MobileFullscreenModal>
  );
}
